import {Component, input} from '@angular/core';
import {Divider} from "primeng/divider";

@Component({
  selector: 'homey-apartment-detail-info-item',
  standalone: true,
  imports: [
    Divider
  ],
  templateUrl: './apartment-detail-info-item.component.html',
})
export class ApartmentDetailInfoItemComponent {
  icon = input.required<string>();
  title = input.required<string>();
}
